import { useEffect } from "react";
import { Card, Skeleton, Tabs } from "antd";
import { useTranslation } from "react-i18next";

import { traineeProgramActions } from "@fitness-app/app-store";

import { useSideTabsPosition } from "~/hooks/useIsMobile";
import TraineeArchivedPrograms from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeTrainingProgram/TraineeArchivedPrograms";
import TraineeProgramBuilder from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeTrainingProgram/TraineeProgramBuilder";
import TraineeProgramInfo from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeTrainingProgram/TraineeProgramInfo";
import TraineeProgramSchedule from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeTrainingProgram/TraineeProgramSchedule";
import { useAppDispatch, useAppSelector } from "~/store/initializeStore";

const TraineeTrainingProgram = () => {
  const sideTabsPosition = useSideTabsPosition();
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["trainees"]);
  const traineeProfile = useAppSelector((store) => store.trainee.profile);
  const { selectedProgram } = useAppSelector((state) => state.traineeProgram);

  const traineeId = traineeProfile?.id;
  const currentProgramId = traineeProfile?.activeTrainingProgramId;

  useEffect(() => {
    if (traineeId) {
      void dispatch(traineeProgramActions.fetchScheduledPrograms({ traineeId }));
    }
  }, [dispatch, traineeId, currentProgramId]);

  return (
    <Card bordered={false} className="!shadow-none">
      <Tabs tabPosition={sideTabsPosition} defaultActiveKey="programInfo">
        <Tabs.TabPane tab={t("program.programInfoTitle")} key="programInfo">
          <TraineeProgramInfo />
        </Tabs.TabPane>
        {traineeProfile?.activeTrainingProgramId ? (
          <>
            <Tabs.TabPane tab={t("program.trainingDays")} key="workouts" destroyOnHidden>
              {selectedProgram?.id !== currentProgramId ? (
                <Skeleton active paragraph={{ rows: 10 }} />
              ) : (
                <TraineeProgramBuilder assignedProgramId={traineeProfile.activeTrainingProgramId} />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab={t("program.scheduleTitle")} key="schedule" forceRender>
              <TraineeProgramSchedule />
            </Tabs.TabPane>
          </>
        ) : null}
        {/*
         * TRE-1833 — poza bramką `activeTrainingProgramId`. Brak bieżącego planu to typowa
         * sytuacja klientki między pakietami, a wtedy historia jest najbardziej potrzebna.
         * `destroyOnHidden` trzyma zapytanie o archiwum do momentu wejścia w zakładkę.
         */}
        {traineeId ? (
          <Tabs.TabPane tab="Poprzednie plany" key="archivedPrograms" destroyOnHidden>
            <TraineeArchivedPrograms traineeId={traineeId} />
          </Tabs.TabPane>
        ) : null}
      </Tabs>
    </Card>
  );
};

export default TraineeTrainingProgram;
